import { Controller } from "@hotwired/stimulus"

// Shortcuts of the To-do tool, mounted on its header so they only fire
// there: 1 list, 2 timeline, 3 hill, n new to-do, e focus the open drawer.
// Ignored while typing.
export default class extends Controller {
  static values = {
    newTodo: String,
    list: String, timeline: String, hill: String
  }

  connect() {
    this._onKeydown = this._handleKeydown.bind(this)
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  _handleKeydown(event) {
    const tag = event.target.tagName
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || event.target.isContentEditable) return
    if (event.ctrlKey || event.metaKey || event.altKey) return

    switch (event.key) {
      case "n": event.preventDefault(); Turbo.visit(this.newTodoValue); break
      case "e": event.preventDefault(); this._editOpenDrawer(); break
      case "1": event.preventDefault(); Turbo.visit(this.listValue); break
      case "2": event.preventDefault(); Turbo.visit(this.timelineValue); break
      case "3": event.preventDefault(); Turbo.visit(this.hillValue); break
    }
  }

  _editOpenDrawer() {
    const drawer = document.getElementById("drawer_frame")
    if (!drawer) return
    const field = drawer.querySelector("input[type='text'], textarea")
    if (field) field.focus()
  }
}
